import { render, staticRenderFns } from "./DocumentationDetail.vue?vue&type=template&id=c9aacb74&"
import script from "./DocumentationDetail.vue?vue&type=script&lang=js&"
export * from "./DocumentationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports